import React, { Fragment } from 'react'

import page from 'hoc/page'
import frontload from 'hoc/frontload'
import Component from 'components/component'
import { DI } from 'modules'
import HelmetWrap from 'components/helmet-wrap'
import Submenu from './submenu'
import { Switch, Route } from 'react-router-dom'
import { about } from 'config/routes'
import AboutContent from './content'

import 'submodules/responsivestyles/src/less/about.less'

export class AboutPage extends Component {
  static preload() {
    return Promise.all([])
  }

  render() {
    const { meta_tag } = this.props.frontpages.info.payload

    return (
      <Fragment>
        <HelmetWrap {...(meta_tag || {})} page="about" />

        <section className="content">
          <div className="iwrap not-found-page">
            <div className="about-container about-container--stretch">
              <Submenu />
              <Switch>
                <Route exact path={about.path} component={AboutContent} />
              </Switch>
            </div>
          </div>
        </section>
      </Fragment>
    )
  }
}

export default page(DI(['frontpages', 'router'])(frontload(AboutPage)))
